(function (t) {
// ru
t.add("label_previous", "\u041d\u0430\u0437\u0430\u0434", "KnpPaginatorBundle", "ru");
t.add("label_next", "\u0412\u043f\u0435\u0440\u0435\u0434", "KnpPaginatorBundle", "ru");
})(Translator);
